module.exports = __webpack_public_path__ + "fonts/Moderat Medium.ee2aa14e.otf";